export default __webpack_public_path__ + "5b2c6a312c092af543cba235102e6d42.jpg";